import React from 'react';

import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

import InputField, { ChangeState, Validation } from '../../InputField';

import getCreditCardExpiry from './validation/getCreditCardExpiry';

export interface ExpirationDateState {
  expiration: string;
  isValid: boolean;
}

interface ExpirationDateInputProps {
  onExpirationDateChange: (state: ExpirationDateState) => void;
  autoFocus?: boolean;
}

const ExpirationDateInput: React.FC<ExpirationDateInputProps> = ({
  onExpirationDateChange,
  autoFocus = false,
}) => {
  const validateExpirationDate = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Validation => {
    const {
      creditCardExpiry,
      creditCardExpiryErrorMessage,
      isCreditCardExpiryValid,
    } = getCreditCardExpiry(event);

    return {
      formattedValue: creditCardExpiry,
      errorState: {
        message: creditCardExpiryErrorMessage,
        error: !isCreditCardExpiryValid,
      },
    };
  };

  const onChange = ({ value, isValid }: ChangeState) => {
    onExpirationDateChange({ expiration: value, isValid });
  };

  return (
    <InputField
      autoComplete="cc-exp"
      id="expiricy-field"
      name="expiricy-field"
      testId="expiricy-field"
      type="numeric"
      onChange={onChange}
      validation={validateExpirationDate}
      autoFocus={autoFocus}
      maxLength={5}
      label={I18N_STRINGS.EXPIRATION_DATE_LABEL}
    />
  );
};

export default ExpirationDateInput;
